class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector('form');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
    })
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // /search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[type]=product&resources[limit]=20&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

class ClearSearch extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      this.clearSearch();
    });
    this.addEventListener('keypress', (e) => {
      if ( e && e.keyCode === 13 ){
        this.clearSearch();
      }
    });
  }

  clearSearch() {
    const searchEl = this.closest("predictive-search")
      searchEl.input.value = '';
      searchEl.close();
  }
}

customElements.define('clear-search', ClearSearch);